exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stripe{color:#fff;display:inline-block;font-size:.75rem;padding:.0625rem .3125rem}.stripe.medium{font-size:.875rem;line-height:1.25rem;padding:.3125rem .625rem}", ""]);

